import script from "./WhiteSpace.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhiteSpace.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__